module.exports = __webpack_public_path__ + "86e357304b17d461a60f03e30dd11465.fbx";